<template>
  <div class="scroll-progress-btn">
    <div class="progress-text-box">
      <span class="progress-text">0%</span>
      <p class="top-text-normal">置顶</p>
    </div>
    <span class="top-text"><i class="el-icon-top" style="margin: 0"></i>置顶</span>
  </div>
</template>
<script>
export default {
  name: "ScrollProgress",
  mounted() {
    const scrollBtn = document.querySelector(".scroll-progress-btn")
    const progressText = document.querySelector(".progress-text")

    // 显示/隐藏按钮
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // 计算滚动百分比
      const scrollPercent = Math.round((scrollPosition / (documentHeight - windowHeight)) * 100)
      progressText.textContent = scrollPercent + "%"

      // 显示按钮
      if (scrollPosition > 256) {
        scrollBtn.classList.add("active")
      } else {
        scrollBtn.classList.remove("active")
      }
    })

    // 点击返回顶部
    scrollBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    })
  }
}
</script>
<style scoped>
.scroll-progress-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 999;
  opacity: 0;
  transform: translateY(20px);
  visibility: hidden;
}

.scroll-progress-btn.active {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

.scroll-progress-btn:hover {
  background: linear-gradient(135deg, #a777e3, #6e8efb);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.scroll-progress-btn .progress-text-box {
  font-size: 14px;
  transition: all 0.3s ease;
}

.scroll-progress-btn .top-text {
  position: absolute;
  opacity: 0;
  transition: all 0.3s ease;
  font-size: 14px;
}

.scroll-progress-btn .top-text-normal {
  font-size: 12px;
  text-align: center;
}

.scroll-progress-btn:hover .progress-text-box {
  opacity: 0;
  transform: translateY(-10px);
}

.scroll-progress-btn:hover .top-text {
  opacity: 1;
  transform: translateY(0);
}

.scroll-progress-btn i {
  margin-right: 5px;
}
</style>